
export enum ChangeFlag {
	CREATED = "CREATED",
	UPDATED = "UPDATED",
	DELETED = "DELETED",
	NONE = "NONE"
}
